import PropTypes from 'ant-design-vue/es/_util/vue-types'
import { RouterView } from 'vue-router'
import GridContent from './components/GridContent'
import * as Vue from 'vue'

import 'ant-design-vue/es/layout/style'
import Layout from 'ant-design-vue/es/layout'
import ConfigProvider from 'ant-design-vue/es/config-provider'

const { Content } = Layout
const { h } = Vue

const WrapContentProps = {
  isChildrenLayout: PropTypes.bool,
  location: PropTypes.any,
  contentHeight: PropTypes.number,
  contentWidth: PropTypes.oneOf(['Fluid', 'Fixed']).def('Fluid')
}

const WrapContent = {
  name: 'WrapContent',
  props: WrapContentProps,
  render (h) {
    const {
      isChildrenLayout,
      contentWidth
    } = this.$props
    // 在 Vue 3 中，$slots.default 是一个函数，需要调用它来获取插槽内容
    // 获取默认插槽内容（应该包含 router-view）
    const defaultSlot = this.$slots.default
    const slotContent = defaultSlot ? defaultSlot() : []
    
    console.log('WrapContent: slotContent', slotContent)
    console.log('WrapContent: slotContent length', Array.isArray(slotContent) ? slotContent.length : 'not array')
    
    // 如果插槽内容为空，直接使用 RouterView
    const children = Array.isArray(slotContent) && slotContent.length > 0 
      ? slotContent 
      : [<RouterView />]
    
    console.log('WrapContent: children', children)
    console.log('WrapContent: children length', Array.isArray(children) ? children.length : 'not array')
    if (Array.isArray(children) && children.length > 0) {
      console.log('WrapContent: children[0] type:', children[0]?.type?.name || children[0]?.type)
      console.log('WrapContent: children[0] is RouterView?', 
        children[0]?.type === RouterView || 
        children[0]?.type?.name === 'RouterView' ||
        children[0]?.type?.__name === 'RouterView'
      )
    }
    
    return (
      <Content>
        <ConfigProvider
          getPopupContainer={(el, dialogContext) => {
            if (isChildrenLayout) {
              return el.parentNode()
            }
            return document.body
          }}
        >
          <div class="ant-pro-basicLayout-children-content-wrap">
            {Vue.h(GridContent, {
              contentWidth: contentWidth
            }, {
              default: () => children
            })}
          </div>
        </ConfigProvider>
      </Content>
    )
  }
}

export default WrapContent
